export const SET_PROJECTS_LIST = 'SET_PROJECTS_LIST';
export const SET_DETAILS_PROJECT = 'SET_DETAILS_PROJECT';
export const UPDATE_DETAILS_PROJECT = 'UPDATE_DETAILS_PROJECT';
export const SET_FILTERS_DATA = 'SET_FILTERS_DATA';
export const SET_ALL_PROJECTS_LIST = 'SET_ALL_PROJECTS_LIST';
